(function ($) {
  const $snsslider = $('.menu_slide');
  $snsslider.slick({
    infinite: true,
    arrows: true,
    dots: true,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 2000,
    centerMode: true
  });
})($224);
